import { FC, ReactNode } from 'react';

export type BadgeVariant =
  | 'default'
  | 'red'
  | 'yellow'
  | 'green'
  | 'blue'
  | 'indigo'
  | 'purple'
  | 'pink'
  | 'orange'
  | 'default-solid'
  | 'red-solid'
  | 'yellow-solid'
  | 'green-solid'
  | 'blue-solid'
  | 'white'
  | 'orange-solid';

const VARIANT_STYLES: Record<BadgeVariant, string> = {
  default: 'bg-gray-50 text-gray-600 inset-ring inset-ring-gray-500/10',
  red: 'bg-red-50 text-red-700 inset-ring inset-ring-red-600/10',
  yellow: 'bg-yellow-50 text-yellow-800 inset-ring inset-ring-yellow-600/20',
  green: 'bg-green-50 text-green-700 inset-ring inset-ring-green-600/20',
  blue: 'bg-blue-50 text-blue-700 inset-ring inset-ring-blue-700/10',
  indigo: 'bg-indigo-50 text-indigo-700 inset-ring inset-ring-indigo-700/10',
  purple: 'bg-purple-50 text-purple-700 inset-ring inset-ring-purple-700/10',
  pink: 'bg-pink-50 text-pink-700 inset-ring inset-ring-pink-700/10',
  orange:
    'bg-[var(--primary-O200)] text-[var(--primary-O1100)] inset-ring inset-ring-[var(--primary-O900)]/20',
  'default-solid': 'bg-gray-600 text-white',
  'red-solid': 'bg-red-600 text-white',
  'yellow-solid': 'bg-yellow-500 text-white',
  'green-solid': 'bg-green-600 text-white',
  'blue-solid': 'bg-blue-600 text-white',
  white: 'bg-white text-gray-600 inset-ring inset-ring-gray-300',
  'orange-solid': 'bg-[var(--primary-O900)] text-white',
};

interface BadgeProps {
  variant?: BadgeVariant;
  children: ReactNode;
  className?: string;
}

export const Badge: FC<BadgeProps> = ({ variant = 'default', children, className = '' }) => (
  <span
    className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${VARIANT_STYLES[variant]} ${className}`}
  >
    {children}
  </span>
);
